export const formatAddress = (a?: string): string => {
  a = a || "";
  const m = a.match(/^(\w*\d+\w*[\s,-]*)+/); // for 11, 12, 13A-14, 15A don't convert commas to newlines
  const p = m ? m[0].length : 0;
  return a.slice(0, p) + a.slice(p).replace(/, */g, "\n");
};
